<template>
  <div class="row align-items-center my-5">
    <div v-for="model in props.models" class="col-lg-3 col-6" :key="model.id">
      <router-link
        :to="{
          name: 'ModelPageChild',
          params: {
            locale: locale,
            name: model.slug,
            complement: 'photo'
          }
        }"
      >
        <div class="card-pagination pr-3">
          <img :src="`${model.cover}`" :alt="model.title" width="290" height="213" />
          <div class="card-body d-flex flex-column align-items-center">
            <h5 class="card-title my-3">{{ model.title }}</h5>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { localeStore } from '../../stores/locale'

  const storeLocale = localeStore()
  const locale = computed(() => storeLocale.locale)

  interface Model {
    id: number
    title: string
    slug: string
    cover: string
  }
  const props = defineProps({
    models: {
      type: Array<Model>,
      required: true
    }
  })
</script>

<style scoped lang="css">
  .card-title {
    height: 19px;
    color: #666666;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
  }

  .card-pagination img {
    width: 100%;
    object-fit: cover;
    height: auto;
  }

  .card-pagination {
    background-color: transparent;
    cursor: pointer;
  }
</style>
